import BaseAdapter from 'Core/adapters/base';

class PaymentAdapter extends BaseAdapter {
  /**
   * Get the photographer availabilities
   *
   * @param {Object} [payment] - payment attributes
   * @return {Promise} - a promise which will resolve to the payment completion status
   */
  static create(url, payment, promotionId) {
    /* eslint-disable camelcase */
    let requestParams = {
      payment: {
        provider_token: payment.providerToken,
        card_id: payment.cardId,
        source: payment.source,
        payment_method: payment.paymentMethod
      },
      promotion_id: promotionId
    };
    /* eslint-enable camelcase */
    return this.prototype.postRequest(url, requestParams);
  }
}

export default PaymentAdapter;
